<ng-container
  *ngIf="{
    container: container$ | async,
    hasValidationError: configuratorFormValidationService.hasValidationError() | async,
    hasError: hasError$ | async,
  } as data">
  <ng-container *ngIf="!data.hasError && data.container && !data.container.routerData.displayOnly">
    <div class="tile-bridge">
      <div class="tile-bridge__divider"></div>
      <udex-tile class="button-tile" [hideShadow]="false">
        <dcp-disable-loading-form>
          <div class="d-flex">
            <ng-container *ngFor="let button of data.container.configuration.buttonActions">
              <udex-button
                *ngIf="button.type === 'redirect'; else defaultButton"
                (click)="redirectToTargetUrl(button.targetUrl)"
                [design]="isPrimaryBtn(button) ? 'Primary' : 'Secondary'"
                [disabled]="!button.targetUrl || data.container.hasPendingChanges"
                size="Large"
                class="udex-mx-4 flex-grow-1"
                >{{ button.description }}
              </udex-button>
              <ng-template #defaultButton>
                <udex-button
                  (click)="onAddToCart(data.container.configuration, data.container.routerData)"
                  data-cy="add-to-cart-button"
                  class="udex-mx-4 flex-grow-1"
                  [disabled]="
                    !data.container?.configuration?.complete ||
                    !data.container?.configuration?.consistent ||
                    data.container?.configuration?.priceSummary?.pricingError ||
                    showSpinner ||
                    data.hasValidationError ||
                    hasExternalError ||
                    data.container.hasPendingChanges
                  "
                  [design]="isPrimaryBtn(button) ? 'Primary' : 'Secondary'"
                  size="Large">
                  <span *ngIf="!showSpinner; else spinner">{{
                    getButtonResourceKey(data.container.routerData, data.container.configuration) !== ''
                      ? (getButtonResourceKey(data.container.routerData, data.container.configuration) | cxTranslate)
                      : button.description
                  }}</span>
                  <ng-template #spinner>
                    <span data-cy="add-to-cart-button-spinner">
                      <ui5-busy-indicator size="Medium" class="white-dots d-flex" active></ui5-busy-indicator
                    ></span>
                  </ng-template>
                </udex-button>
              </ng-template>
            </ng-container>
          </div>
        </dcp-disable-loading-form>
      </udex-tile>
    </div>
  </ng-container>
</ng-container>
